const VALID_LANGS = ['EN', 'FR', 'NL', 'SW']

export const getTranslationValue = ({
  translations = {},
  keyPath,
  language = 'EN',
  fallback = '',
}) => {
  if (!keyPath) return fallback

  const selectedLang = String(language || 'EN')
    .trim()
    .toUpperCase()
  const resolvedLang = VALID_LANGS.includes(selectedLang) ? selectedLang : 'EN'

  const keys = keyPath.split('.')
  let result = translations

  for (const key of keys) {
    result = result?.[key]
    if (Array.isArray(result)) {
      result = result[0]
    }
    if (result === undefined) {
      break
    }
  }

  if (result && typeof result === 'object') {
    return result[resolvedLang] ?? result.EN ?? fallback
  }

  return typeof result === 'string' ? result : fallback
}

export const getLocalizedProductText = ({
  translations = {},
  language = 'EN',
  keyPath,
  replacements = {},
  fallback = '',
}) => {
  let value = getTranslationValue({
    translations,
    keyPath,
    language,
    fallback,
  })

  if (typeof value !== 'string') return fallback

  Object.entries(replacements).forEach(([key, replacement]) => {
    value = value.replace(new RegExp(`\\{${key}\\}`, 'g'), String(replacement))
  })

  return value
}

export const getProductUrl = (product) => {
  if (!product) return null

  return (
    product.official_url ||
    product.product_url ||
    product.productUrl ||
    product.url ||
    null
  )
}

export const getProductRoutinePrompt = (
  product,
  translations = {},
  language = 'EN',
) => {
  const productName = product?.name || 'this product'

  return getLocalizedProductText({
    translations,
    language,
    keyPath: 'productFlow.routinePrompt',
    replacements: { productName },
    fallback: `You selected ${productName}. Would you like to view a routine using this product?`,
  })
}

export const getProductDeclinePrompt = (
  product,
  translations = {},
  language = 'EN',
) => {
  const productName = product?.product_name || product?.name || 'this product'

  return getLocalizedProductText({
    translations,
    language,
    keyPath: 'productFlow.declinePrompt',
    replacements: { productName },
    fallback: `What made you decide not to buy ${productName}?`,
  })
}

export const getProductPageOpenedMessage = (
  translations = {},
  language = 'EN',
) => {
  return getLocalizedProductText({
    translations,
    language,
    keyPath: 'productFlow.pageOpenedMessage',
    fallback:
      'I opened the official product page in a new tab. Would you like to continue exploring or log out?',
  })
}

export const getContinueExploringMessage = (
  translations = {},
  language = 'EN',
) => {
  return getLocalizedProductText({
    translations,
    language,
    keyPath: 'productFlow.continueExploring',
    fallback: 'Great — you can keep browsing the recommended products.',
  })
}

export const getLocalizedActionText = ({
  translations = {},
  language = 'EN',
  keyPath,
  fallback = '',
}) => {
  return getLocalizedProductText({
    translations,
    language,
    keyPath,
    fallback,
  })
}
